<template>
  <div class="modal fade" id="priceModelConfigModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-exchange mr-5"></i>{{"shipping-config" | translate}}: {{this.model.label}}</h4>
        </div>
        <div class="modal-body">
          <template v-for="alert in alerts">
            <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
              <h4>
                <i v-if="alert.type == 'success' || alert.type == 'warning' " class="icon fa fa-check"></i>
                <i class="icon fa fa-ban" v-else></i>
                {{ 'alert_' + alert.type | translate }}!</h4>
              <template v-if="alert.type === 'danger' && alert.message.message === undefined">
                  <span v-for="msg, key in alert.message">
                    {{ msg[0] }}<br>
                  </span>
              </template>
              <template v-else-if="alert.type === 'danger' && alert.message.message !== undefined">
                {{ alert.message.message | translate }} <span v-if="alert.message.message == 'Error saving data GLN'">{{alert.message.glns}}</span>
              </template>
              <template v-else>
                {{ alert.message }}
              </template>
            </b-alert>
          </template>
          <div class="row">
            <div class="col-xs-12 mb-10">
              <div class="input-group col-xs-12">
                <label for="freeShippingFrom">{{"freeShippingFrom" | translate}}</label>
                <input type="number" v-validate="'required|decimal'" v-model="model.freeShippingFrom" name="freeShippingFrom" id="freeShippingFrom" class="form-control"/>
                <div><span v-show="errors.has('freeShippingFrom')" class="small text-danger">{{ errors.first('freeShippingFrom') }}</span></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 mb-10">
              <div class="input-group col-xs-12">
                <label for="shipping">{{"shipping" | translate}}</label>
                <input type="number" v-validate="'required|decimal|max_value:' + model.maxShippingCost" name="shipping" v-model="model.shipping" id="shipping" class="form-control"/>
                <div><span v-show="errors.has('shipping')" class="small text-danger">{{ errors.first('shipping') }}</span></div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="confirmEdit" :disabled="errors.any() || deactivateSaveButton" class="btn btn-app btn-success"
                  @click="send(model)"><span class="fa fa-save "></span>{{'save' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: [
    'model', 'modelRefresh'
  ],
  data() {
    return {
      deactivateSaveButton: false,
      alerts: []
    }
  },
  methods: {
    send (model) {
      this.deactivateSaveButton = true
      API.post(`uvp/shipping`, this.model)
        .then($res => {
          this.alerts.push({dismiss: 4, type: 'success', message: 'success', icon: 'icon fa fa-check', show: true})
          Object.assign(this.modelRefresh, model)
        })
        .catch(error => {
          this.alerts.push({dismiss: 10, type: 'danger', message: error.response.data, icon: 'icon fa fa-ban', show: true})
        }).finally(() => {
          this.deactivateSaveButton = false
        })
    }
  }
}
</script>
<style>
input[type=number] {
  appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/ShippingConfigModal.vue